module.exports = __webpack_public_path__ + "static/img/hipspanic_r.8268313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hipspanic_r.png
// module id = ZZdd
// module chunks = 1